(function () {
	'use strict';

	angular
		.module('app')
		.directive('phoneNumberValidator', phoneNumberValidator);

	phoneNumberValidator.$inject = ['$window'];

	function phoneNumberValidator($window) {
		// Usage:
		//     <phoneNumberValidator></phoneNumberValidator>
		// Creates:
		// 
		var directive = {
			restrict: 'A',
			require: 'ngModel',
			link: link
		};
		return directive;

		function link($scope, $element, $attrs, $ctrl) {
			$ctrl.$parsers.unshift(function (value) {
				let isValid = true;
				let phoneNumberRegexPattern = /((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}/;

				if (value) {
					isValid = phoneNumberRegexPattern.test(value);
					$ctrl.$setValidity('invalidPhoneNumber', isValid);

					return isValid ? value : "";
				} else {
					return isValid;
				}
			});
		}
	}
})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/validators/_phoneNumberValidator.js
// module id = 18
// module chunks = 0